export const FLAVOR_TEXT = 'Rachel West is';
export const WEBSITE_TITLE_A = "Scarlet's";
export const WEBSITE_TITLE_B = 'Daughter';
export const WEBSITE_EMAIL = 'rwest@scarletsdaughter.com';
export const WEBSITE_EMAIL_LINK = `mailTo:${WEBSITE_EMAIL}`;
export const ICON_ALT = `E-Mail ${WEBSITE_TITLE_A} ${WEBSITE_TITLE_B}`;
export const MAIN_IMAGE_ALT = 'Rachel In Studio';
